export default "__VITE_ASSET__DNmrZwXI__"